/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { ClientDto } from './client-dto';
import { PaginationMetaDto } from './pagination-meta-dto';
 /**
 *
 *
 * @export
 * @interface ClientPaginatedResponseDto
 */
export interface ClientPaginatedResponseDto {

    /**
     * @type {Array<ClientDto>}
     * @memberof ClientPaginatedResponseDto
     */
    data: Array<ClientDto>;

    /**
     * @type {PaginationMetaDto}
     * @memberof ClientPaginatedResponseDto
     */
    meta: PaginationMetaDto;
}
